import { type MotifComponent, type MotifComponentProps, m } from '../../motif';
import {
  blackThemeSideNavVars,
  grayThemeSideNavVars,
  whiteThemeSideNavVars,
} from './SideNavigation.palette';

export const snapSideNavigationPrimaryVars: MotifComponentProps<MotifComponent.SIDE_NAVIGATION> = {
  ...whiteThemeSideNavVars,
  '--side-navigation-desktop-bar-bg-color': m('--neutral-v0'),
  '--side-navigation-desktop-border-color': m('--neutral-v700'),
  '--side-navigation-desktop-border-width': '1px',
  '--side-navigation-right-padding': m('--spacing-xl'),
  '--side-navigation-left-padding': m('--spacing-xxxl'),
} as const;

export const snapSideNavigationSecondaryVars: MotifComponentProps<MotifComponent.SIDE_NAVIGATION> =
  {
    ...blackThemeSideNavVars,
    '--side-navigation-desktop-bar-bg-color': m('--neutral-v700'),
    '--side-navigation-desktop-border-color': m('--neutral-v0'),
    '--side-navigation-desktop-border-width': '1px',
    '--side-navigation-right-padding': m('--spacing-xl'),
    '--side-navigation-left-padding': m('--spacing-xxxl'),
  } as const;

export const snapSideNavigationTertiaryVars: MotifComponentProps<MotifComponent.SIDE_NAVIGATION> = {
  ...grayThemeSideNavVars,
  '--side-navigation-desktop-bar-bg-color': m('--bg-color'),
  '--side-navigation-desktop-border-color': m('--neutral-v700'),
  '--side-navigation-desktop-border-width': '1px',
  '--side-navigation-right-padding': m('--spacing-xl'),
  '--side-navigation-left-padding': m('--spacing-xxxl'),
} as const;
